<script lang="ts" setup>
import { PlaceType } from "@/models/place";
import { useSearchFormStore } from "@/stores/search_form";
const searchFormStore = useSearchFormStore();
const route = useRoute();

function onSubmit(page) {
  return navigateTo(searchFormStore.route);
}
</script>

<template lang="pug">
v-sheet(
  class="pa-3"
  color="grey-lighten-5"
  rounded
  elevation="1"
)
  v-row()
    v-col(cols="6" sm="4")
      PrefectureFilterDialog(
        :placeType="searchFormStore.placeType"
      )
        template(#dialog-activator="slotProps")
          v-text-field(
            label="都道府県"
            variant="outlined"
            placeholder="選択する"
            append-inner-icon="mdi-plus-circle"
            v-bind="slotProps"
            hide-details="true"
          )
            template(v-slot:prepend-inner)
              v-icon(icon="mdi-map-marker" color="#099b8d")

    v-col(cols="6" sm="4")
      TagFilterDialog(
        :placeType="searchFormStore.placeType"
      )
        template(#dialog-activator="slotProps")
          v-text-field(
            label="特徴"
            variant="outlined"
            placeholder="選択する"
            append-inner-icon="mdi-plus-circle"
            v-bind="slotProps"
            hide-details="true"
          )
            template(v-slot:prepend-inner)
              v-icon(icon="mdi-tag-outline" color="#099b8d")
    v-col(cols="6" sm="4")
      v-text-field(
        v-model="searchFormStore.keyword"
        label="キーワード"
        variant="outlined"
        placeholder="施設名など"
        update:modelValue="searchFormStore.setKeyword"
      )
        template(v-slot:prepend-inner)
          v-icon(icon="mdi-pencil" color="#099b8d")
    v-col
      v-btn(
        outlined
        @click="onSubmit"
        type="submit"
        size="x-large"
        block
        :class="searchFormStore.placeType"
      ): b 検索
  v-row
    v-col
      v-chip(
        color="accent"
        :key="feature.sym"
        v-for="feature in searchFormStore.features"
        size="small"
        closable
        @click:close="searchFormStore.closeChip(feature)"
        value="feature"
      ) {{feature.name}}


</template>

<style lang="scss" scoped>
.v-btn {
  color: white;
  &.dog-run {
    background-color: #50b460;
  }

  &.dog-cafe {
    background-color: #f4774a;
  }

  &.dog-hotel {
    background-color: #51a3dc;
  }

  &.pet-salon {
    background-color: #f08e9f;
  }

  &.campsite {
    background-color: #f6e75d; // yellow-lighten-3
    b {
      color: #424242; // grey-darken-3
    }
  }
}
</style>
